<template>
  <DsFeaturesSection
    title-base="Características"
    title-highlight="generales"
    title-id="preventa-features-title"
    card-layout="inline"
    :features="features"
  />
</template>

<script setup lang="ts">
import bungalowIcon from '../../../../../assets/preventa/Vector (1).svg'
import calendarCheckIcon from '../../../../../assets/preventa/calendar_check_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 1.svg'
import creditCardHeartIcon from '../../../../../assets/preventa/credit_card_heart.svg'
import homeAndGardenIcon from '../../../../../assets/preventa/home_and_garden_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 1.svg'
import paymentsIcon from '../../../../../assets/preventa/payments_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24 (1) 1.svg'
import realEstateAgentIcon from '../../../../../assets/preventa/Vector.svg'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const features = [
  {
    id: 'housing-type',
    iconSrc: homeAndGardenIcon,
    title: 'Tipo de vivienda',
    description: 'Vivienda nueva'
  },
  {
    id: 'seller',
    iconSrc: realEstateAgentIcon,
    title: 'Vendedor',
    description: 'Desarrollador o constructor'
  },
  {
    id: 'buyer',
    iconSrc: bungalowIcon,
    title: 'Comprador',
    description: 'Persona física'
  },
  {
    id: 'first-payment',
    iconSrc: paymentsIcon,
    title: 'Primer pago',
    description: 'Hasta 18 meses de gracia'
  },
  {
    id: 'contract-term',
    iconSrc: calendarCheckIcon,
    title: 'Plazo del contrato',
    description: '18 meses'
  },
  {
    id: 'direct-debit',
    iconSrc: creditCardHeartIcon,
    title: 'Domiciliación',
    description: 'Obligatoria desde la contratación'
  }
]
</script>
